import envConfig from './config';
import { EnvironmentType } from './types';

const nonEnvConfig = {
  LOG_API_CALLS: envConfig.ENVIRONMENT !== EnvironmentType.PRODUCTION,
  ONLY_PORTFOLIO_FLOW: false,
};

export const config = {
  ...nonEnvConfig,
  ...envConfig,
};

export type MainConfig = typeof config;
